__turbopack_context__.v({
  "container": "ModelListModel-module__z6dL0a__container",
  "fadeInItems": "ModelListModel-module__z6dL0a__fadeInItems",
  "img": "ModelListModel-module__z6dL0a__img",
  "imgWrap": "ModelListModel-module__z6dL0a__imgWrap",
  "instagram": "ModelListModel-module__z6dL0a__instagram",
  "instagramGrid": "ModelListModel-module__z6dL0a__instagramGrid",
  "instagramIcon": "ModelListModel-module__z6dL0a__instagramIcon",
  "instagramVisible": "ModelListModel-module__z6dL0a__instagramVisible",
  "measurement": "ModelListModel-module__z6dL0a__measurement",
  "measurementValue": "ModelListModel-module__z6dL0a__measurementValue",
  "measurements": "ModelListModel-module__z6dL0a__measurements",
  "measurementsList": "ModelListModel-module__z6dL0a__measurementsList",
  "name": "ModelListModel-module__z6dL0a__name",
  "nameNoPadding": "ModelListModel-module__z6dL0a__nameNoPadding",
  "overlay": "ModelListModel-module__z6dL0a__overlay",
  "spacing--lg": "ModelListModel-module__z6dL0a__spacing--lg",
  "spacing--md": "ModelListModel-module__z6dL0a__spacing--md",
  "spacing--sm": "ModelListModel-module__z6dL0a__spacing--sm",
  "spacing--xl": "ModelListModel-module__z6dL0a__spacing--xl",
  "spacing--xs": "ModelListModel-module__z6dL0a__spacing--xs",
  "spacing--xxl": "ModelListModel-module__z6dL0a__spacing--xxl",
  "spacing--xxs": "ModelListModel-module__z6dL0a__spacing--xxs",
  "spacing--xxxl": "ModelListModel-module__z6dL0a__spacing--xxxl",
  "spacing--xxxs": "ModelListModel-module__z6dL0a__spacing--xxxs",
  "tiktok": "ModelListModel-module__z6dL0a__tiktok",
  "tiktokGrid": "ModelListModel-module__z6dL0a__tiktokGrid",
  "tiktokIcon": "ModelListModel-module__z6dL0a__tiktokIcon",
  "tiktokVisible": "ModelListModel-module__z6dL0a__tiktokVisible",
});
